<template>
	<div class="letter_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('notice.message') }}</div>
		</div>
		<div class="msg_num">
			<!-- <div class="all_msg"><span>{{ data.ok_read_num }}</span>{{ $t('notice.unRead') }}</div> -->
			<!-- <div class="read">全部标为已读</div> -->
		</div>
		<div class="msg_box">
			<div class="item" v-for="item in data.list" @click="$router.push('/notice/' + item.id)">
				<div class="tits">
					<div class="lefts">
						<img src="@/assets/images/msg.png" alt="">
					</div>
					<div class="rights">
						<div class="tips" style="font-weight: bold;">
							<div class="tips-box">
								<div class="text_nowrap">{{ $t('xttz') }}</div>
								<div class="msg-text" v-if="item.is_read">{{ $t('yds') }}</div>
								<div class="msg-active" v-else>{{ $t('wds') }}</div>
							</div>
						</div>
						<div class="tips" style="margin-bottom: 8px;color: #999;">{{ item[title] }}</div>
						<div class="time" style="color: #2f86ce;">{{ formatTime(item.time) }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';

export default {
	name: "login",
	data() {
		return {
			title: "title",
			content: "content",
			data: {},
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			Fetch('/user/notice').then((r) => {
				this.data = r.data;
			});
		},
		formatTime(dateStr) {
			// 创建日期对象
			const date = new Date(dateStr);

			// 获取年、月、日
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const dateStrFormatted = `${month}-${day}`;

			// 获取当前日期（本地时间）
			const today = new Date();
			// 设置为当天的开始时间（00:00:00）
			today.setHours(0, 0, 0, 0);

			// 计算目标日期的开始时间
			const targetDate = new Date(dateStr);
			targetDate.setHours(0, 0, 0, 0);

			// 计算时间差（天数）
			const diffDays = Math.floor((targetDate - today) / (1000 * 60 * 60 * 24));

			// 根据不同情况返回不同结果
			if (diffDays === 0) {
				return this.$t('jr');
			} else if (diffDays === -1) {
				return this.$t('zr');
			} else {
				return dateStrFormatted;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.red_top_bg {
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10;
}

.back_left {
	background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
	color: #000000;
}

.msg_num {
	margin-top: 44px;
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: space-between;
	padding: 0 11px 0 20px;
	align-items: center;
	overflow: hidden;

	.all_msg {
		font-size: 14px;
		color: rgba(0, 0, 0, .8);
		font-weight: bold;

		span {
			color: #F03041;
		}
	}

	.read {
		font-size: 12px;
		color: #3D96FF;
	}
}

.msg_box {
	width: 97%;
	margin: 0 auto;
	margin-left: 2%;
	border-radius: 5px;
	background: rgba(255, 255, 255, 1);
	padding: 0 13px 0 10px;

	.item {
		width: 100%;
		margin-bottom: 12px;
		box-shadow: -2px 0px 1px #2c76b3;
		padding: 10px 4px 10px 10px;
		background: #E9F0F8;
		position: relative;
		border-radius: 8px;

		.icon-right {
			width: 24px;
			height: 24px;
			display: block;
			margin-left: auto;
		}

		&:last-of-type {
			border-bottom: none;
		}

		.tits {
			width: 100%;
			display: flex;
			padding-right: 8px;

			.lefts {
				width: 42px;
				height: 42px;
				background: #DCEDFF;
				padding: 8px;
				border-radius: 50%;

				img {
					display: block;
					width: 100%;
					height: 100%;
				}
			}

			.rights {
				width: calc(100% - 52px);
				margin-left: 10px;

				.tips {
					font-size: 14x;
					width: 100%;
					margin-bottom: 8px;
				}

				.time {
					width: 100%;
					text-align: left;
					font-size: 12px;
					color: #999;
				}
			}
		}

		.content {
			height: 100px;
			margin-top: 2px;
			line-height: 18px;
			font-size: 13px;
			color: rgba(0, 0, 0, .6);
		}
	}
}

.tips-box {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.text_nowrap {
	width: 100%;
	color: #333;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	padding-right: 35px;
}

.msg-text {
	color: #999;
}

.msg-active {
	color: #2c76b3;
}

.msg-text,
.msg-active {
	width: fit-content;
	position: relative;
	white-space: nowrap;
}

.msg-text::after {
	content: '';
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #ccc;
	position: absolute;
	left: -12px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
}

.msg-active::after {
	content: '';
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #fc5a5a;
	position: absolute;
	left: -12px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
}
</style>
